import { spacer12 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { useEncoreContextType } from "../../hooks/useEncoreContextType";
import { cssColorValue, rootStyle, semanticColors, typeStyleBody2, viola } from "../../styles";
export var Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "fd2j9b-0"
})(["", ";", ";color:", ";padding-inline-end:", ";"], rootStyle(), function () {
  return useEncoreContextType(typeStyleBody2(), viola());
}, cssColorValue(semanticColors.textSubdued), spacer12);